/*
Author : Raphaël Dardeau


Markup :

<form action="login" method="post" data-submit="submit.php">
	<div class="js-form-error"></div>
	<input type="hidden" name="foo" value="bar" />

    <label class="form__row js-submit-required">
        <span class="form__label">Email</span>
        <input class="form__input" type="text" name="email" data-submit-reg="/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g" />
        <span class="form__note" js-submit-reginfo">Incorrecte syntax</span>
    </label>
</form>
<div class="js-form-confirm"></div>


Setup :

$(function() {
	$(document).ajaxSubmit({
		callback:function(action, datas) {
			console.log("callback!");
		}
	});
});
*/
;(function ( $, window, document, undefined ) {
    var pluginName = "ajaxSubmit",
        defaults = {
        	callback: function(/*action, message, datas*/) {}
        };

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
			this.setEvents();
        },

		setEvents: function() {
			$(document).on("submit", "form[data-submit]", $.proxy(this.submitForm, this));
			$(document).on("click", "a[data-submit]", $.proxy(this.submitForm, this));
			$(document).on("keypress change", ".js-submit-required, [data-submit-reg]", function() {
				$(this).removeClass("is-failing");
				$(this).parent().removeClass("is-failing");
			});
		},

        setElements: function(e) {
			this.$form = $(e.currentTarget);
			this.$button = this.$form.find("[type=submit]");
			this.$error = this.$form.find(".js-form-error");
			this.$success = this.$form.siblings(".js-form-success");
			this.$required = this.$form.find(".js-submit-required");
			this.$regex = this.$form.find("[data-submit-reg]");
		},

		setVars: function() {
			this.url = this.$form.data("submit");
			this.action = (this.$form.attr("action")) ? this.$form.attr("action") : (this.$form.data("submit-action")) ? this.$form.data("submit-action") : '';
			this.method = (this.$form.attr("method")) ? this.$form.attr("method") : (this.$form.data("submit-method")) ? this.$form.data("submit-method") : 'POST';
			this.params = (this.$form.data("submit-params")) ? this.$form.data("submit-params") : this.$form.serialize();
		},

		submitForm: function(e) {
			if (this.$xhr)
				return false;

			this.setElements(e);
			this.setVars();
			this.checkForm();

			if (this.$form.find(".is-failing").length || $("#checkUserType").is(":checked")) {
				this.setAlert("Le formulaire contient des erreurs");
				if (!this.$form.parents(".js-popin").length) {
					$("html, body").animate({
						scrollTop: this.$form.find(".is-failing").first().offset().top - 100
					});
				}
				return false;
			}

			this.$form.trigger("submitting");

			if (this.$button.length)
				this.$button.addClass("is-loading");
			else
				this.$form.removeClass("is-loading");
			this.$xhr = $.ajax(this.url, {
				type: this.method,
				data: this.params,
                dataType: "json"
			}).always($.proxy(function(json) {
				if (json.code && json.code == 200) {
					if (this.action) {
						this.settings.callback(this.action, json);
					} else if (json.message) {
						this.setConfirm(json.message);
					}
				} else if (json.message) {
					this.setError(json.message);
				} else {
					this.setError("Une erreur est survenue");
				}
				if (this.$button.length)
					this.$button.removeClass("is-loading");
				else
					this.$form.removeClass("is-loading");
				this.$xhr = null;
			}, this));
			e.preventDefault();
		},

		checkForm: function(element) {
			try {
				this.$required.each(function() {
					var inputs = $(this).find("input, select, textarea");
					var inputTest = false;
					inputs.each(function() {
						if ($(this).attr("type") == 'radio' || $(this).attr("type") == 'checkbox') {
							if ($(this).is(":checked"))
								inputTest = true;
						} else if ($(this).val())
							inputTest = true;
					});
					if (!inputTest)
						$(this).addClass("is-failing");
				});
				this.$regex.each(function() {
					var val = $(this).val();
					var reg = $(this).data("submit-reg");
					var pattern = reg.substring(reg.indexOf("/") + 1, reg.lastIndexOf("/"));
					var modifiers = reg.substring(reg.lastIndexOf("/") + 1);
					if (!modifiers)
						modifiers = "g";
					var pattern = new RegExp(pattern, modifiers);
					if (val && !pattern.test(val))
						$(this).parent().addClass("is-failing");
				});
			} catch(err) {
			}
		},

		setAlert: function(message) {
			if (message) {
				if (this.$error.length) {
					this.$error.html(message);
				} else if (popin) {
					var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
					html += '<p class="paragraph"><span class="message message--error">' + message +'</span></p>';
					html += '</div>';
		            popin.setPopin({
		                html: html,
		                classname: "popin popin--toaster",
		                globalClassname: "is-toasting"
		            });
				}
			}
		},

		setError: function(message) {
			if (message) {
				if (this.$error.length) {
					this.$error.html(message);
				} else if (popin) {
					var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
					html += '<p class="paragraph"><span class="message message--error">' + message +'</span></p>';
					html += '</div>';
		            popin.setPopin({
		                html: html,
		                classname: "popin popin--xs popin--auto"
		            });
				}
			}
		},

		setConfirm: function(message) {
			if (message) {
				if (this.$success.length) {
					this.$success.html(message);
					this.$form.hide();
				} else if (popin) {
					var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
					html += '<p class="paragraph"><span class="message message--success">' + message +'</span></p>';
					html += '</div>';
		            popin.setPopin({
		                html: html,
		                classname: "popin popin--toaster",
		                globalClassname: "is-toasting"
		            });
				}
			}
		}

	});

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );
